export default "__VITE_ASSET__1d865592__"